import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicDivisionDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismicdivision-container',
  templateUrl: './seismicdivision-container.component.html',
  styleUrls: ['./seismicdivision-container.component.scss']
})
export class SeismicDivisionContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismicdivisions$: Observable<SeismicDivisionDto[]>;
  loading: boolean;
  isLoadingSeismicDivision$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingSeismicDivision$ = this.gatwayFacade.isLoadingGateway("SeismicDivision");
    this.seismicdivisions$ = this.gatwayFacade.loadGateway("SeismicDivision");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicDivision(deletedValue: any) {
    this.gatwayFacade.remove("SeismicDivision", deletedValue);
  }


// this method control both the create and update

  onSubmitSeismicDivision(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SeismicDivisions;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicDivision = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllSeismicDivision.push(pullData[i]);
    }
  }

// check if the addAllBank array is not empty, then dispatch the data to the store
   if(addAllSeismicDivision.length > 0) {
    this.gatwayFacade.add('SeismicDivision', addAllSeismicDivision);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('SeismicDivision', allUpdates, ['id']);
  }

   }


}
